<!-- =========================================================================================
  File Name: DeviceCategorySidebar.vue
  Description: Category - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/TitleTranslate.json"></i18n>

<template>
	<el-dialog
		class="custom-dialog"
		:title="$t('TitleManagement')"
		:visible.sync="isSidebarActiveLocal"
		:closed="() => $store.dispatch('titleManagement/toggleTitleCategorySideBar', { status: false })"
	>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6" id="list-employees">
				<div slot="header" class="flex flex-grow justify-end">
					<h1>fsdf</h1>
					<vs-button v-if="mixinIsCanCreateTitle" type="filled" class="w-auto sm:w-1/3 font-bold" @click="addNewData">{{ $t("Actions.AddNew") }}</vs-button>
				</div>
				<vs-table
					id="title-management-table"
					ref="table"
					class="stack-table"
					:pagination="!!$store.state.titleManagement.titles.length"
					:max-items="itemsPerPage"
					:data="$store.state.titleManagement.titles"
				>
					<template slot="thead">
						<vs-th sort-key="name">
							<h6 class="uppercase font-semibold text-black">{{ $t("Title") }}</h6>
						</vs-th>
						<vs-th sort-key="code">
							<h6 class="uppercase font-semibold text-black">{{ $t("Department") }}</h6>
						</vs-th>
						<vs-th sort-key="role">
							<h6 class="uppercase font-semibold text-black">{{ $t("Role") }}</h6>
						</vs-th>
						<vs-th class="no-sorter"></vs-th>
					</template>

					<template slot-scope="{ data }">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data-header="$t('Title')">
									<p class="employee-name">{{ tr.name }}</p>
								</vs-td>

								<vs-td :data-header="$t('Department')">
									<p class="employee-code">{{ tr.department ? tr.department.name : "" }}</p>
								</vs-td>

								<vs-td :data-header="$t('Role')">
									<p class="employee-role">{{ tr.role ? tr.role.name : "" }}</p>
								</vs-td>

								<vs-td class="whitespace-no-wrap">
									<i v-if="tr.can_update" class="nucleo nucleo-edit mr-3" @click.stop="editData(tr)"></i>
									<i v-if="tr.can_delete" class="nucleo nucleo-trash-can" @click.stop="showDeleteConfirm(tr.id)"></i>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</div>
		</PerfectScrollbar>

		<popup-create-or-update-title-item :isPopupActive="isPopupActive" @closePopup="toggleCategoryPopup" :data="popupData" />
	</el-dialog>
</template>

<script>
import { titlePermissions, getUserPermissions } from "@/mixins/mixins.js";
import LiquorTree from "liquor-tree";

import PopupCreateOrUpdateTitleItem from "./PopupCreateOrUpdateTitleItem";
import "vue-tree-halower/dist/halower-tree.min.css";

export default {
	mixins: [getUserPermissions(titlePermissions)],
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			isPopupActive: false,

			popupData: {},
			treeDataKey: 0,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},

			itemsPerPage: 10
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		}
	},
	methods: {
		forceRerender() {
			this.treeDataKey += 1;
		},
		toggleCategoryPopup(val = false) {
			this.isPopupActive = val;
		},
		addNewData() {
			this.popupData = {};
			this.toggleCategoryPopup(true);
		},
		editData(category) {
			try {
				this.popupData = category || {};
				this.toggleCategoryPopup(true);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("titleManagement/deleteTitle", { id: id });
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteTitleSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	components: {
		LiquorTree,
		PopupCreateOrUpdateTitleItem
	},

	created() {
		console.log("Title Cate");
		this.$store.subscribe(mutaion => {
			if (mutaion.type === "titleManagement/SET_TITLE_CATEGORY_SIDEBAR_STATUS" && mutaion.payload) {
				this.$store.dispatch("titleManagement/fetchTitles", { limit: -1 });
			}
		});
	}
};
</script>
